import { render, staticRenderFns } from "./additional-info.component.vue?vue&type=template&id=70868cb6&scoped=true&"
import script from "./additional-info.component.vue?vue&type=script&lang=ts&"
export * from "./additional-info.component.vue?vue&type=script&lang=ts&"
import style0 from "./additional-info.component.vue?vue&type=style&index=0&id=70868cb6&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70868cb6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VForm,VRow,VSelect,VTextField})
